<template>
  <div class="itmform-container">
    <ul id="right-click-menu" tabindex="-1" ref="right" v-if="viewMenu" v-on:blur="closeMenu"  v-bind:style="{top:top, left:left}">
        <li  @click="insertRow">Insert</li>
        <template v-if="form.items.length > 2">
          <li @click="moveUpRow">Move Up</li>
          <li @click="moveDownRow">Move Down</li>
        </template>
        <li @click="deleteRow">Delete</li>
    </ul>
    <ValidationObserver class="needs-validation form-custom-format " v-bind:class="{'was-validated' : validated}" tag="form" ref="observer" v-slot="{passes}" @submit.prevent="onSubmitForm()">
       <ThatsWindow ref="window" title="Sales Transaction" windowClass="collection height-auto" scrollClass='collection height-auto' @deleteYes="emitDelete" :height="800" :width="1300" :formStatus="formStatus" @dialog-state="dialogState" :group="group">
            <template #left-button>
                <template v-if="formLoading">
                  <mdb-btn color="elegant" size="sm" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Loading...
                  </mdb-btn>
                </template>
                <template v-else>
                  <template v-if="(formStatus == 'update' || formStatus == 'create') && returmItem === false && modify === false">
                  <mdb-btn color="elegant" size="sm" @click="passes(onSubmitForm)" :disabled="viewLoading">Save</mdb-btn>
                  </template>
                  <template v-if="(formStatus == 'update' || formStatus == 'create') && returmItem === false && modify === true">
                  <mdb-btn color="elegant" size="sm" @click="passes(onSubmitForm)" :disabled="viewLoading">Save Changes</mdb-btn>
                  </template>
                  <template v-if="selectedTbo.length > 0">
                  <mdb-btn color="elegant" size="sm" @click="passes(onSubmitForm)" :disabled="viewLoading">Save & Create Customer PO</mdb-btn>
                  </template>

                  <template v-if="formStatus == 'update'">
                      <template v-if="invoice.payments.length > 0">
                        <mdb-btn @click="fnPrint('/sales/invoice/'+form.token_id)" color="elegant" size="sm" :disabled="viewLoading">Print Invoice</mdb-btn>
                    </template>
                    <template v-else>
                    <mdb-btn @click="fnPrint('/sales/transactions/'+form.token_id)" color="elegant" size="sm" :disabled="viewLoading">Print Quotation</mdb-btn>
                      </template>
                  </template>
                </template>

                <template v-if="selected.length > 0 && modify === true && returmItem === false">
                    <mdb-btn color="elegant" size="sm" @click="deleteItem">Delete</mdb-btn>
                  </template>
              </template>

            <template #right-button>
              <template v-if="formStatus == 'update'">
                <template v-if="invoice.series === null || parseFloat(invoice.balance) > 0 && modify === false && returmItem === false && (active === 0  || active === 1)">
                  <mdb-btn color="elegant" size="sm" @click="openPaymentWindow" :disabled="viewLoading">Make Payment</mdb-btn>
                </template>
                <template v-if="invoice.series !== null && checkSystemSupport && modify === false && returmItem === false && (active === 0  || active === 1)">
                  <mdb-btn color="elegant" size="sm" @click="openPaymentWindow" :disabled="viewLoading">Add Payment</mdb-btn>
                </template>
                <template v-if="invoice.series !== null && (checkSystemSupport || checkShowroomManager) && modify === false && returmItem === false && active === 0">
                  <mdb-btn color="elegant" size="sm" @click="enableModify" :disabled="viewLoading">Modify</mdb-btn>
                </template>
                <template v-if="invoice.series !== null && checkSystemSupport && modify === false && returmItem === false && modifyReturmItem === false && active === 3">
                  <mdb-btn color="elegant" size="sm" @click="enableModifyCreditNote" :disabled="viewLoading">Modify Credit Note</mdb-btn>
                </template>
                <template v-if="invoice.series !== null && (checkSystemSupport || checkShowroomManager) && (modify === true || modifyReturmItem === true )">
                  <mdb-btn color="elegant" size="sm" @click="cancelModification" :disabled="viewLoading">Cancel</mdb-btn>
                </template>

                <template v-if="(invoice.series !== null && ((form.status === 'delivered' || form.status === 'collected' || form.status === 'cancel') && form.attr.payment_status === 'full-payment')) && (checkSystemSupport || checkShowroomManager) && modify === false && returmItem === false && active === 0">
                  <mdb-btn color="elegant" size="sm" :disabled="viewLoading" @click="returnItems">Return</mdb-btn>
                </template>

                <template v-if="(invoice.series !== null && ((form.status === 'delivered' || form.status === 'collected' || form.status === 'cancel') && form.attr.payment_status === 'full-payment')) && (checkSystemSupport || checkShowroomManager) && returmItem === true && modify === false  && active === 0">
                  <mdb-btn color="elegant" size="sm" :disabled="hasSelected" @click="requestCreditNote">Request Credit Note</mdb-btn>
                  <mdb-btn color="elegant" size="sm" :disabled="viewLoading" @click="cancelModification">Cancel</mdb-btn>
                </template>

                <template v-if="invoice.payments.length> 0">
                    <span class="invoice-balance">Total Balance : {{ $helpers.addSeparatorsNF(invoice.balance)}} QAR</span>
                </template>

              </template>


            </template>
          <template v-if="invoice.payments.length> 0">
            <span class="invoice-number">Sales Invoice #: {{invoice.series}}</span>
          </template>
          <div class="mt-1 pl-3 pr-3">
            <mdb-tabs class="table-tabs mb-0 form" :active="active" default :links="tabs" @activeTab="getActiveTabIndex" >
              <template :slot="'form-slot'">
                <mdb-row class="tab-row">
                    <mdb-col col="6" class="tab-col pl-0">
                      <template v-if="form.date !== null">
                      <ThatsDatePicker :show_error="showError" tabindex="1" labelClass="col-md-4" fieldClass="col-md-8 pl-0" label="Date" placeholder="Date" vid="date" name="date" v-model="form.date" :validated="validated" :rules="'required'" size="sm" :disabled="disabled"/>
                      </template>
                      <template v-if="formStatus === 'update' && form.status !== 'no-remarks'">
                          <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Customer" vid="name" name="name" v-model="form.attr.name" size="sm" :disabled="disabled"/>
                      </template>
                      <template v-else>
                        <ThatsCustomMultiSelect :multiple="false"  labelClass="col-md-4" fieldClass="col-md-8  pl-0" label="Customer" v-model="form.customer_id" :reduce="customer => customer.value" :reduceLabel="'opt'" :options="customer" :rules="'required'" :clearable="false" :disabled="disabled" @select="getCustomerSelected($event)" :addButton="true" @newWindow="openCustomer" @onSearch="searchCustomer" :selected_option="true"></ThatsCustomMultiSelect>
                      </template>
                      <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Customer Mobile No." vid="mobile" name="mobile" v-model="form.attr.mobile" size="sm" :disabled="disabled"/>
                      <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Customer Address" vid="address" name="address" v-model="form.attr.address" size="sm" :disabled="false"/>
                      <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Instructions" vid="instructions" name="instructions" v-model="form.attr.instructions" size="sm" :disabled="disabled"/>
                    </mdb-col>
                    <mdb-col col="6" class="tab-col pl-0 pr-0">
                        <ThatsSeriesInput :show_error="showError" tabindex="1" labelClass="col-md-4" fieldClass="col-md-8 pl-0" label="Transaction ID" placeholder="Transaction ID" vid="series" name="series" v-model="form.series" :validated="validated" :rules="''" :keycode="false" size="sm" :disabled="true" />
                        <mdb-row>
                            <mdb-col sm="4" class="tab-col">
                                <label v-bind:class="'col-form-label'">Sold By</label>
                            </mdb-col>
                            <mdb-col sm="4" class="tab-col">
                                <ThatsInput :showLabel="false" tabindex="2" labelClass="col-sm-6" fieldClass="col-sm-12 pl-0" label="Sold By" :placeholder="form.sold_by" vid="sold_by" name="sold_by" v-model="form.sold_by" size="sm" :disabled="true" />
                            </mdb-col>
                            <mdb-col sm="4" class="tab-col">
                                <ThatsMultiSelect :multiple="true"  labelClass="col-md-4" fieldClass="col-md-8  pl-0" label="partner" v-model="form.attr.partner" :reduce="label => label.code" :reduceLabel="'label'" :options="partner" :rules="''" :filterable="false" :clearable="false"></ThatsMultiSelect>
                            </mdb-col>
                          </mdb-row>

                        <ThatsMultiSelect :multiple="false"  labelClass="col-md-4" fieldClass="col-md-8  pl-0" label="Order Status" v-model="form.status" :reduce="label => label.code" :reduceLabel="'label'" :options="status" :rules="'required'" :filterable="false" :clearable="false" :disabled="noInvoiceDisabled"></ThatsMultiSelect>
                        <template v-if="form.status === 'for-delivery-schedule'">
                          <template v-if="form.hasOwnProperty('delivery_schedule')">
                            <ThatsDatePicker :show_error="showError" tabindex="1" labelClass="col-md-4" fieldClass="col-md-8 pl-0" label="Date Request" placeholder="Date Request" vid="date_request" name="date_request" v-model="form.delivery_schedule.date" :validated="validated" :rules="'required'" size="sm" :disabled="noInvoiceDisabled"/>
                            <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Delivery Remarks" :placeholder="form.attr.delivery_remarks" vid="delivery_remarks" name="delivery_remarks" v-model="form.delivery_schedule.remarks" size="sm" :disabled="noInvoiceDisabled" />
                          </template>
                        </template>
                        <template v-if="form.status ==='to-be-order'">
                          <ThatsDatePicker :show_error="showError" tabindex="1" labelClass="col-md-4" fieldClass="col-md-8 pl-0" label="Expected Date" placeholder="Expected Date" vid="expected_date" name="expected_date" v-model="form.attr.expected_date" :validated="validated" :rules="'required'" size="sm" :disabled="noInvoiceDisabled"/>
                            <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="TBO Details" :placeholder="form.attr.tbo_details" vid="tbo_details" name="tbo_details" v-model="form.attr.tbo_details" size="sm" :disabled="noInvoiceDisabled" />
                        </template>
                        <ThatsMultiSelect :multiple="false"  labelClass="col-md-4" fieldClass="col-md-8  pl-0" label="Payment Status" v-model="form.attr.payment_status" :reduce="label => label.code" :reduceLabel="'label'" :options="paymentMethod" :rules="''" :filterable="false" :clearable="false" :disabled="noInvoiceDisabled"></ThatsMultiSelect>
                        <template v-if="form.attr.hasOwnProperty('discount_remarks')">
                          <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Discount Remarks" vid="discount_remarks" name="discount_remarks" v-model="form.attr.discount_remarks" size="sm" :disabled="true"/>
                        </template>
                    </mdb-col>
                  </mdb-row>

                 <el-table id="itemTable" ref="itemTable" :key="tblKey" border :data="form.items" class="input-table mt-2 itemTable" style="width: 100%" @selection-change="handleSelectionChange" :summary-method="getSummaries" show-summary :cell-class-name="cell" @row-contextmenu="rowContectMenu">
                            <template v-if="showCheckBox">
                              <el-table-column type="selection" width="35" :selectable="canSelectRow"> </el-table-column>
                            </template>
                            <el-table-column type="index" width="50" label="SQ" align="center"> </el-table-column>
                            <el-table-column label="SKU" :width="150">
                              <template slot-scope="scope">
                                <template v-if="disabled">
                                    {{scope.row.code}}
                                </template>
                                <template v-else>
                                  <GridVueSelect v-model="scope.row.code"
                                                 :reduce="item => item.code"
                                                 :reduceLabel="'code'"
                                                 :options="items"
                                                 :filterable="false"
                                                 :clearable="false"
                                                 @onSearch="statusKeyUp"
                                                 @onFocus="statusKeyUpFocus"
                                                 @select="getSelected($event,scope.$index)"
                                                 :disabled="disabled"></GridVueSelect>
                                </template>

                              </template>
                            </el-table-column>
                            <el-table-column label="Image" width="90">
                            <template slot-scope="scope">
                              <img :src="scope.row.default" style="width:100%" />
                            </template>
                          </el-table-column>
                            <el-table-column label="Item Name" :row-class-name="''">
                              <template slot-scope="scope">
                                <template v-if="disabled">

                                    {{scope.row.name}}
                                </template>
                                <template v-else>
                                <input type="text" class="form-control grid-input thats-form-control" v-model="scope.row.name" @keydown.enter="addNewRow(scope.$index)" :disabled="disabled" />
                                </template>
                              </template>
                            </el-table-column>
                            <template v-if="form.invoice.series === null">
                              <el-table-column label="Qty" :width="70" align="right">
                                <template slot-scope="scope">
                                  <template v-if="enableModifyAndCreditNote(scope.row)">

                                    {{scope.row.qty}}
                                </template>
                                <template v-else>
                                  <input type="number" min="1" class="form-control grid-input thats-form-control text-right" v-model="scope.row.qty" @keyup="calculate(scope.$index,$event)" @change="calculate(scope.$index,$event)" @keydown.enter="addNewRow(scope.$index)" :disabled="enableModifyAndCreditNote(scope.row)" />
                                </template>

                                </template>
                              </el-table-column>
                              <el-table-column label="Price" :width="100" align="right">
                                <template slot-scope="scope">
                                  <template v-if="enablePrice(scope.row)">
                                        <input type="tel" class="form-control grid-input thats-form-control text-right" v-model="scope.row.formatted_price" @keydown.enter="addNewRow(scope.$index)"  @input="calculatePrice(scope.$index,$event)" @focus="removeFormat(scope.$index)" @blur="formatOnBlur(scope.$index)"/>
<!--                                     <vue-numeric  class="form-control grid-input thats-form-control text-right" currency="" separator="," v-model="scope.row.formatted_price" v-bind:precision="2"  @input="calculate(scope.$index,$event)"></vue-numeric> -->
                                    </template>
                                    <template v-else>
                                        <input type="tel" class="form-control grid-input thats-form-control text-right" v-model="scope.row.formatted_price" disabled/>
                                      </template>
                                </template>
                              </el-table-column>
                              <el-table-column label="Amount" :width="100" align = "right">
                                <template slot-scope="scope">
                                  <input type="text" class="form-control grid-input thats-form-control text-right" v-model="scope.row.amount" @keydown.enter="addNewRow(scope.$index)" :disabled="true" />
                                </template>
                              </el-table-column>
                              <el-table-column label="Discount" :width="100" align = "right">
                                <template slot-scope="scope">
                                  <span v-html="scope.row.discount"></span>
                                  <template v-if="scope.row.code !== null && scope.row.name !== null && disabled === false">
                                  <a href="javascript:void(0)" class="discount-a" @click="openDiscount(scope.$index,scope.row)"><mdb-icon icon="ellipsis-v" /></a>
                                  </template>
                                </template>
                              </el-table-column>
                              <el-table-column label="Total Amount" :width="120" align = "right">
                                <template slot-scope="scope">
                                  <input type="text" class="form-control grid-input thats-form-control text-right" v-model="scope.row.total" @keydown.enter="addNewRow(scope.$index)" :disabled="true" />
                                </template>
                              </el-table-column>
                            </template>
                            <template v-else>
                              <el-table-column label="Qty" :width="70" align="right">
                                <template slot-scope="scope">
                                  <template v-if="enableModifyAndCreditNote(scope.row)">

                                    {{scope.row.qty}}
                                </template>
                               <!--  <template v-else><input type="number" min="1" class="form-control grid-input thats-form-control text-right" v-model="scope.row.qty" @keyup="calculate(scope.$index)" @change="calculate(scope.$index)" @keydown.enter="addNewRow(scope.$index)" :disabled="enableModifyAndCreditNote" /> -->
                                <template v-else>
                                  <input type="number" min="1" class="form-control grid-input thats-form-control text-right" v-model="scope.row.qty" @keyup="calculate(scope.$index,$event)" @change="calculate(scope.$index,$event)" @keydown.enter="addNewRow(scope.$index)" :disabled="enableModifyAndCreditNote(scope.row)" />
                                </template>
                                </template>
                              </el-table-column>
                              <el-table-column label="Price" :width="100" align = "right">
                                <template slot-scope="scope">
                                  <input type="text" class="form-control grid-input thats-form-control text-right" v-model="scope.row.formatted_price" :disabled="enablePrice(scope.row)" />
                                </template>
                              </el-table-column>
                              <el-table-column label="Amount" :width="100" align = "right">
                                <template slot-scope="scope">
                                  <input type="text" class="form-control grid-input thats-form-control text-right" v-model="scope.row.amount" :disabled="true" />
                                </template>
                              </el-table-column>
                              <el-table-column label="Discount" :width="100" align = "right">
                                <template slot-scope="scope">
                                  <span v-html="scope.row.discount"></span>
                                 <template v-if="scope.row.code !== null && scope.row.name !== null && disabled === false">
                                  <a href="javascript:void(0)" class="discount-a" @click="openDiscount(scope.$index,scope.row)"><mdb-icon icon="ellipsis-v" /></a>
                                  </template>
                                </template>
                              </el-table-column>
                              <el-table-column label="Total Amount" :width="120" align = "right">
                                <template slot-scope="scope">
                                  <input type="text" class="form-control grid-input thats-form-control text-right" v-model="scope.row.total" :disabled="true" />
                                </template>
                              </el-table-column>
                            </template>
                            <el-table-column label="Remarks" :width="120">
                              <template slot-scope="scope">
                                <input type="text" class="form-control grid-input thats-form-control" v-model="scope.row.remarks" :disabled="enableModifyAndCreditNote(scope.row)" />
                              </template>
                            </el-table-column>
                            <template v-if="form.invoice.series === null">
                              <el-table-column :width="75">
                                <template slot-scope="scope" slot="header">
                                  <el-checkbox :indeterminate="isIndeterminate" v-model="checkAllTbo" @change="handleCheckAllChange">TBO</el-checkbox>
                                </template>
                                <template slot-scope="scope">
                                  <el-checkbox v-model="scope.row.tbo" style="margin-left:6px" @change="handleCheckedTboChange">TBO</el-checkbox>
                                </template>
                              </el-table-column>
                            </template>

                          </el-table>




                          <table class="el-table">
                <tr>
                  <template v-if="!disabled">
                  <td></td>
                  </template>

                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td style="width:100px"  class="text-right">


                    <!-- <ThatsCheckbox :label="''" vid="enable-discount" orientation="inline" name="enable-discount" :data="[]" v-model="form.more_discount.enable" :validated="validated" :rules="''" size="sm" :multiple="false" style="float: right; display: block; width: 25px;"/> -->
</td>
                  <td style="width:100px"><el-checkbox v-model="form.more_discount.enable" :disabled="disabled">More Discount </el-checkbox></td>
                  <td style="width:100px"><input type="text" class="form-control grid-input thats-form-control text-right" v-model="form.more_discount.discount" @keydown.enter="addMoreDiscount()" :disabled="disabled" /></td>
                  <td style="width:120px" class="text-right">
                      <strong>{{form.total}}</strong>
                  </td>
                  <template v-if="disabled">
                      <td style="width:130px"></td>
                  </template>
                  <template v-else>
                  <td style="width:114px"></td>
                  </template>
                </tr>
            </table>
              </template>
              <template :slot="'credit-notes'">
                <el-table border :data="form.credit_note_items" class="input-table mt-0" style="width: 100%">

                  <template v-if="showCheckBoxCreditNote">
                              <el-table-column type="selection" width="35" :selectable="canSelectRow"> </el-table-column>
                            </template>

                      <el-table-column label="SKU" width="150">
                        <template slot-scope="scope">
                           {{scope.row.code}}
                        </template>
                      </el-table-column>
                      <el-table-column label="Image" width="90">
                        <template slot-scope="scope">
                            <img :src="scope.row.default" style="width:90px" />
                        </template>
                      </el-table-column>
                      <el-table-column label="Item Name" :row-class-name="''">
                          <template slot-scope="scope">
                          {{scope.row.name}}
                          </template>
                      </el-table-column>

                      <el-table-column label="Qty" :width="70" align="right">
                      <template slot-scope="scope">
                            <template v-if="checkSystemSupport === true && scope.row.status === 'for-approval' && modifyReturmItem === true">
                            <input type="number" min="1" v-on:change="quantityChange(scope.row,$event)" class="form-control grid-input thats-form-control text-right" v-model="scope.row.qty" :max="scope.row.max" @keyup="calculate(scope.$index,$event)" @change="calculate(scope.$index,$event)" />
                          </template>
                          <template v-else>
                              {{scope.row.qty}}
                          </template>
                          <!-- {{scope.row.qty}} -->
                      </template>
                      </el-table-column>
                      <el-table-column label="Price" :width="100" align = "right">
                      <template slot-scope="scope">
                          {{scope.row.price}}
                      </template>
                      </el-table-column>
                      <el-table-column label="Amount" :width="100" align = "right">
                      <template slot-scope="scope">
                          {{scope.row.amount}}
                      </template>
                      </el-table-column>
                      <el-table-column label="Discount" :width="100" align = "right">
                      <template slot-scope="scope">
                          {{scope.row.discount}}
                      </template>
                      </el-table-column>
                      <el-table-column label="Total Amount" :width="120" align = "right">
                      <template slot-scope="scope">
                          {{scope.row.total}}
                      </template>
                      </el-table-column>
                      <el-table-column label="Remarks" :width="120" align = "right">
                      <template slot-scope="scope">
                          {{scope.row.remarks}}
                      </template>
                      </el-table-column>
                      <el-table-column label="Status" :width="120" align = "right">
                      <template slot-scope="scope">
                          {{scope.row.status_label}}
                      </template>
                      </el-table-column>
                  </el-table>
              </template>
              <template :slot="'delivery-notes'">
                <el-table ref="itemsTable" border :data="form.delivery_notes" class="input-table mt-0" style="width: 100%">

                      <el-table-column label="Series" width="150">
                            <template slot-scope="scope">
                              {{scope.row.series}}
                            </template>
                          </el-table-column>
                      <el-table-column label="Date" width="100">
                            <template slot-scope="scope">
                              {{scope.row.date}}
                            </template>
                          </el-table-column>
                      <el-table-column label="Item Details">
                        <template slot-scope="scope">
                          {{scope.row.delivered_items}}
                        </template>
                      </el-table-column>
                      <el-table-column label="Delivery Remarks">
                        <template slot-scope="scope">
                          {{scope.row.remarks}}
                        </template>
                      </el-table-column>
                      <el-table-column label="Delivery Note" width="120">
                        <template slot-scope="scope">
                          <mdb-btn @click="fnPrint('/delivery/print-note/'+scope.row.token_id)" color="elegant" size="sm">Print</mdb-btn>
                        </template>
                      </el-table-column>

                    </el-table>
              </template>
              <template :slot="'invoice-slot'">
                 <mdb-row >
                    <mdb-col col="6">
                      <ThatsDatePicker :show_error="showError" tabindex="1" labelClass="col-md-4" fieldClass="col-md-8 pl-0" label="Date" placeholder="Date" vid="date" name="date" v-model="form.date" :validated="validated" :rules="'required'" size="sm" :disabled="true"/>
                      <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Customer Mobile No." vid="mobile" name="mobile" v-model="form.attr.mobile" size="sm" :disabled="true"/>
                      <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Customer Address" vid="address" name="address" v-model="form.attr.address" size="sm" :disabled="true"/>
                    </mdb-col>
                    <mdb-col col="6">

                      <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Instructions" vid="instruction" name="instruction" v-model="form.attr.instruction" size="sm" :disabled="true"/>
                      <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Other Details" vid="other_details" name="other_details" v-model="form.attr.other_details" size="sm" :disabled="true"/>
                    </mdb-col>

                  </mdb-row>

                  <el-table border :data="invoice.payments" class="input-table mt-2" style="width: 100%" :height="'250px'">
                    <el-table-column label="Series">
                      <template slot-scope="scope">
                        <a href="javascript:void(0)" @click="openPayment(scope.row)" v-html="scope.row.series"></a>

                      </template>
                    </el-table-column>
                    <el-table-column label="Date">
                      <template slot-scope="scope">
                        <input type="text" class="form-control grid-input thats-form-control" v-model="scope.row.date" :disabled="true"/>
                      </template>
                    </el-table-column>
                    <el-table-column label="Mode of Payment">
                      <template slot-scope="scope">
                        <input type="text" class="form-control grid-input thats-form-control" v-model="scope.row.mode_of_payment" :disabled="true"/>
                      </template>
                    </el-table-column>
                    <el-table-column label="Payment Description" width="160">
                      <template slot-scope="scope">
                        <input type="text" class="form-control grid-input thats-form-control" v-model="scope.row.payment_method" :disabled="true"/>
                      </template>
                    </el-table-column>
                    <el-table-column label="Amount" :width="100">
                      <template slot-scope="scope">
                        <input type="text" class="form-control grid-input thats-form-control text-right" :value="scope.row.formatted_amount" :disabled="true" />
                      </template>
                    </el-table-column>
                     <el-table-column :width="100" label="Receipt">
                        <template slot-scope="scope">
                            <a href="javascript:void(0)" @click="fnPrint('/sales/receipt/'+scope.row.token_id)" color="elegant" size="sm"><span class="badge badge-dark text-uppercase">Print</span></a>
                        </template>
                    </el-table-column>
                  </el-table>

              </template>
              <template :slot="'form-attachment'">
                     <ThatsFile labelClass="col-sm-5" fieldClass="col-sm-7 pl-0" label="Attachment" vid="sales-transaction-attachment" name="sales-transaction-attachment" v-model="form.attachment" :disabled="false" :showLabel="false" :accept="'*'"></ThatsFile>
              </template>
            </mdb-tabs>


          </div>
       </ThatsWindow>
          </ValidationObserver>
      <ContactsForm ref="contactForm" :group="3" @success="contactSuccess"></ContactsForm>
      <PaymentForm ref="paymentForm" :group="(group + 1)" @success="paymentSuccess" @print="fnPrint"></PaymentForm>
      <DiscountForm ref="discount" :group="3" @apply="applyDiscount"></DiscountForm>
      <PrintWindow ref="printWindow" :group="3" :url="printUrl"></PrintWindow>
  </div>
</template>
<script>
import { mdbBtn,mdbContainer, mdbRow,mdbCol, mdbIcon, mdbCard, mdbTabs, mdbTab, mdbTabItem, mdbTabContent, mdbTabPane} from "mdbvue";
import { ValidationObserver } from "vee-validate";
import { mapActions,mapGetters, mapMutations } from 'vuex'


import { userData } from '../../helpers/user'
// import { isGeneralManager } from '../../helpers/headers'

import { ThatsWindow,ThatsInput, ThatsSeriesInput,ThatsPriceInput,ThatsFieldset, ThatsRadio, ThatsAutocomplete,ThatsNumber, ThatsAutosuggest,ThatsTextarea, ThatsDatePicker, ThatsMultiSelect, ThatsGridSelect, ThatsFile, ThatsBtn, ThatsCustomMultiSelect, ThatsCheckbox} from '../../components/thats/Thats'

import { MessageBox } from 'element-ui';
import Fuse from 'fuse.js'
import unformat from 'accounting-js/lib/unformat.js'
import formatMoney from 'accounting-js/lib/formatMoney.js'
import ContactsForm from '../contacts/ContactsForm'
import DiscountForm from './DiscountForm'
import PaymentForm from './PaymentForm'
import PrintWindow from '../../components/thats/PrintWindow'
import GridVueSelect from './GridVueSelect'

import TableFooter from './TableFooter';
import Sortable from 'sortablejs'
import Checkbox from './Checkbox'
import axios from 'axios'

export default {
  props : {
    group : {
      type : Number,
      default : 2
    }
  },
    components: {
        mdbContainer,
        mdbBtn,
        mdbRow,
        mdbCol,
        mdbIcon,
        mdbCard,
        mdbTabs,
        mdbTab,
        mdbTabItem,
        mdbTabContent,
        mdbTabPane,

        ValidationObserver,
        ThatsWindow,
        ThatsInput,
        ThatsSeriesInput,
        ThatsPriceInput,
        ThatsFieldset,
        ThatsRadio,
        ThatsAutocomplete,
        ThatsAutosuggest,
        ThatsNumber,
        ThatsTextarea,
        ThatsDatePicker,
        ThatsMultiSelect,
        ThatsGridSelect,
        ThatsFile,
        ThatsBtn,
        ThatsCheckbox,
        ThatsCustomMultiSelect,
        PrintWindow,
        GridVueSelect,
        ContactsForm,
        DiscountForm,
        PaymentForm,
        TableFooter,

        Checkbox

  },

    data : () => ({
      testing : false,
      isIndeterminate : false,
      checkAllTbo : false,
      modifyReturmItem : false,
      returmItem : false,
      request : null,
      selectedTbo : [],
      requests : [],
      disabled : false,
      modify : false,
      printUrl : '',
      active : 1,
      validated : false,
      form : null,
      formOriginal : null,
      formLoading : false,
      response : {
        error : null,
        message : null
      },
      selected : [],
      tabs : [
                { text: 'Sales Details', slot: 'form-slot' }
              ],
      delivery_status : [],
      showError : false,
      status : [],
      paymentMethod : [],
      items : [],
      customer : [],
      partner : [],

      discountForm : null,
      discountFormIndex : null,
      paymentForm : {
                series : 0,
                date : "",
                mode : "full-payment",
                method : "cash",
                customer : "",
                attr : {},
                description : null,
                invoice_series : null,
                amount : 0,
                reference : null,
                transaction_id : null,
                invoice : {
                  series : null,
                  balance : 0,
                  paid : 0,
                  amount : 0,
                },

              },
      paymentFormStatus : 'update',
      customFooter : {rows : [{name : "demo"},{remarks : "remarks"}], columns : [{
              field : 'name'
          },{
              field : 'remarks'
          }]},
      total : 0,
      context: null,
      viewMenu: false,
      top: '0px',
      left: '0px',
      newArrange : [],
      sortableState : {},
      sortableStateStatus : true,
    }),


  created : function() {
      var self = this;
      const formItemVar = this.formItemVar();
      if(this.formStatus == 'create'){
        this.form = this.formVar();

        this.form.items.push(formItemVar);

        this.nextCode()
        this.currentDateSetter();
        this.tabs = [
                { text: 'Sales Details', slot: 'form-slot' },

              ]

      }
       this.optionsHandler();
       this.discountForm = this.formItemVar();

        const {settings} = JSON.parse(localStorage.getItem('user'));
        this.paymentMethod = settings.payment_mode
        this.status = settings.sales_transaction_order_status;

        // console.log(this.$options);


        // new Sortable(tbody);

        /*  */
    },

  mounted(){

      const arr = [
          {name : "test1", code : "test-1"},
          {name : "test2", code : "test-2"},
          {name : "test3", code : "test-3"},
          {name : "test4", code : "test-4"},
          {name : "test5", code : "test-5"},
          {name : "test6", code : "test-6"},
          {name : "test7", code : "test-7"},
      ];

      arr.splice(0, 0, arr.splice(2, 1)[0]);
/*       const tbody = this.$refs.itemTable.$el.querySelector(
        ".el-table__body-wrapper tbody"
      );

      console.log("mounted");
      console.log(tbody); */
  },

  updated(){
    const tbody = this.$refs.itemTable.$el.querySelector(
        ".el-table__body-wrapper tbody"
      );

      console.log("updated");
      console.log(tbody);
  },
    methods: {

      ...mapActions('ContactsModule',[ 'GetContacts' ]),
      ...mapActions('TransactionModule',[
        'getPartner',
        'storeRecord',
        'updateRecord',
        'filterItems',
        'updateStatus',
        'getRecord',
        'storeCreditNote',

      ]),
      ...mapActions('MakePaymentModule',[
        'getCustomerCreditNotes'
      ]),
      ...mapMutations('MakePaymentModule',[
        'setPaymentForm',
      ]),
      ...mapMutations('TransactionModule',[
        'setFormStatusCreate',
        'setFormRecord',
        'setFormStatusUpdate'
      ]),
      ...mapMutations('DiscountModule',[
        'setDiscountForm',
      ]),
      ...mapMutations('TableModule',[
        'SetPage'
      ]),

      formVar(){
        return {
          series : "",
          date : "",
          status_index : 0,
          status : "no-remarks",
          attr : {
            name : null,
            mobile : null,
            address : null,
            instruction : null,
            other_details : null,
            payment_status : 'no-payment',
            expected_date : null,
            tbo_details : null,
            partner : [],
          },
          customer : {
            name : null,
            mobile : null,
            address : null,
          },
          user_id : null,
          sold_by : null,
          customer_id : null,
          payment_method : 'cash',
          items : [],
          credit_note_items : [],
          delivery_notes : [],
          attachment : [],
          invoice : {
                        series : null,
                        date : "",
                        balance : 0,
                        paid : 0,
                        attachment : [],
                        payments : [],
                    },
          delivery_schedule : {
            date : "",
            remarks : null,
            status : 'for-delivery-schedule',
          },
          total : 0,
          more_discount : {
              enable : false,
              discount : 0,
          }
        }
      },

      formItemVar(){
        return {
                item_id: null,
                code: null,
                name : null,
                category : null,
                description: null,
                reference: null,
                qty: null,
                formatted_price: 0,
                price: 0,
                amount: 0,
                discount: 0,
                discount_type: null,
                custom_discount: {
                  apply : true,
                  discount : 0,
                  off_price : 0,
                  promo : 0,
                },
                total: 0,
                tbo: false,
                remarks: null
              }
      },
/* start */
paymentSuccess(response){
  this.setFormRecord(response.data)
  this.$emit('success',response.data)
},
updatePaymentSuccess(v){
  const self = this;

  self.getRecord({token_id : self.form.token_id}).then((response) => {
    self.active = 1
  })
},
applyDiscount(v){

  const frm = v.form;
    const qty = frm.qty;
      let price = frm.price;
      let discount = 0;
      let remarks = null;

      if(frm.promotions.length > 0 && frm.discount_type === 'promo'){
        const itemPromo = frm.promotions[0];
        const discountValue = this.computeDiscount(qty,price,itemPromo,frm.discount_type,frm.custom_discount);

        const discount = unformat(discountValue);
        frm.discount = formatMoney(discount, { symbol: "", precision: 2, thousand: ",", decimal: "." });


        frm.discount = this.computeDiscount(qty,price,itemPromo,frm.discount_type,frm.custom_discount);
        frm.remarks = this.setRemarks(qty,itemPromo);
        frm.total = this.computeTotalAmount(qty, price, frm.discount)
      }

      if(frm.discount_type === 'discount'){
        const itemPromo = frm.promotions[0];

         const discountValue = this.computeDiscount(qty,price,itemPromo,frm.discount_type,frm.custom_discount);

        const discount = unformat(discountValue);
        frm.discount = formatMoney(discount, { symbol: "", precision: 2, thousand: ",", decimal: "." });


        // frm.discount = this.computeDiscount(qty,price,itemPromo,frm.discount_type,frm.custom_discount);
        frm.remarks = this.setRemarks(qty,frm.custom_discount);
        frm.total = this.computeTotalAmount(qty, price, frm.discount)
      }


   this.$set(this.form.items, v.index, frm)



    /*   if(frm.promotions.length > 0){
        const itemPromo = frm.promotions[0];
        discount = this.computeDiscount(qty,price,itemPromo,frm.discount_type,frm.custom_discount);
          remarks = this.setRemarks(qty,itemPromo);

      }

      this.$set(this.form.items[v.index], 'discount', discount)
      this.$set(this.form.items[v.index], 'remarks', remarks)
      this.$set(this.form.items[v.index], 'total', this.computeTotalAmount(qty, price, discount))
      this.$set(this.form.items[v.index], 'custom_discount', frm.custom_discount) */


},
cell({row, column, rowIndex, columnIndex}) {
  const self = this;
  if(self.formStatus === 'update'){
    if(columnIndex ===5){
        return 'cell-align-center';
      }
  }

  if(self.formStatus === 'create'){
    if(columnIndex ===6){
        return 'cell-align-center';
      }
  }

      return null;
},
openDiscount(index,row){
  this.setDiscountForm({index : index, form: row});
  this.$refs.discount.openDialog();
},

getSummaries(param) {
  const self = this;
        const { columns, data } = param;
        const sums = [];
        const numberColumns = [2,3,4,5,6,7,8]

        let totalCol = 3;
        let totalQty= 4;
        let totalPrice= 5;
        let totalAmount= 6;
        let totalDiscount= 7;
        let totalTotal= 8;

        if((self.formStatus === 'create')){
            totalCol = 4;
            totalQty= 5;
            totalPrice= 6;
            totalAmount= 7;
            totalDiscount= 8;
            totalTotal= 9;
        }

        columns.forEach((column, index) => {
          if (index === totalCol) {
            sums[index] = 'Total';
            return;
          }


          if (index === totalQty) {
            const qty = data.map(item => {
                return (item.code !== null && item.name !== null) ? parseInt(item.qty) : 0
              })

              if (!qty.every(qty => isNaN(qty))) {
                  sums[index] = qty.reduce((prev, curr) => {
                  const value = Number(curr);
                  if (!isNaN(value)) {
                    return prev + curr;
                  } else {
                    return prev;
                  }
                }, 0);
              }
            return;
          }

          if (index === totalAmount) {
            const amount = data.map(item => {
                return parseInt(item.qty) * parseFloat(item.price);
              });

              if (!amount.every(amount => isNaN(amount))) {
                  const sum = amount.reduce((prev, curr) => {
                  const value = Number(curr);
                  if (!isNaN(value)) {
                    return prev + curr;
                  } else {
                    return prev;
                  }
                }, 0);

                sums[index] = this.formatNumber(sum)

              }

            return;
          }
          if (index === totalDiscount) {
// console.log(data)
            const discount = data.map(item => {
              let d = 0;
                  if(item.hasOwnProperty("promotions") && item.promotions.length > 0){
                    const itemPromo = item.promotions[0];
                    d = self.computeDiscount(item.qty,item.price,itemPromo,item.discount_type,item.custom_discount);
                    // alert(d)
                  }else{
                    d = unformat(item.discount)
                  }
                return d;
              })




              if (!discount.every(discount => isNaN(discount))) {
                  const sum = discount.reduce((prev, curr) => {
                  const value = Number(curr);
                  if (!isNaN(value)) {
                    return prev + curr;
                  } else {
                    return prev;
                  }
                }, 0);

                sums[index] = this.formatNumber(sum)

              }
            return;
          }

          if (index === totalTotal) {
            const total = data.map(item => {
             let d = 0;


              if(item.hasOwnProperty("promotions") && item.promotions.length > 0){
                const itemPromo = item.promotions[0];
                d = this.computeDiscount(item.qty,item.price,itemPromo,item.discount_type,item.custom_discount);
              }

              if(item.discount_type === 'discount'){
                  const itemPromo = item.promotions[0];
                  d = this.computeDiscount(item.qty,item.price,itemPromo,item.discount_type,item.custom_discount);

                }


                return self.computeTotalAmountNumber(item.qty,item.price,d);;
              });

              if (!total.every(total => isNaN(total))) {
                  const sum = total.reduce((prev, curr) => {
                  const value = Number(curr);
                  if (!isNaN(value)) {
                    return prev + curr;
                  } else {
                    return prev;
                  }
                }, 0);


                //  this.form.total =  this.formatNumber(sum)
                 this.total =  this.formatNumber(sum)
                sums[index] = this.formatNumber(sum)

              }


            return;
          }



          });

          // this.toggleCheck()

        return sums;
      },
    getActiveTabIndex(index){
      this.active = index
    },

openPaymentWindow(){
  const paymentformVar = {
    transaction : this.form,
    payment_reference : [],

  }

  this.getCustomerCreditNotes(this.form)

  this.setPaymentForm(paymentformVar);
  this.$refs.paymentForm.openDialog()
},


array_move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing
},

move(arr, old_index, new_index) {
    while (old_index < 0) {
        old_index += arr.length;
    }
    while (new_index < 0) {
        new_index += arr.length;
    }
    if (new_index >= arr.length) {
        var k = new_index - arr.length;
        while ((k--) + 1) {
            arr.push(undefined);
        }
    }
     arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
   return arr;
},

    optionsHandler(){
      const self = this;
      // this.dispatchFilterItems({transaction_date : this.form.date})
      // this.linksHandler();
      this.getPartner().then((response) => {
          self.partner = response
      })

    },
    destroySortable(){
      this.sortableStateStatus = false
      this.sortableState = null
    },
    initSortable(){
        const self = this;
        this.disableSortable();

        // if(this.form.items.length > 0){


          const tbody = this.$refs.itemTable.$el.querySelector(
            ".el-table__body-wrapper tbody"
          );

          self.sortableState = Sortable.create(tbody,{
          onEnd: function (evt) {
          //   const oldIndex = evt.oldIndex;
          //   const newIndex = evt.newIndex;
          //   const toArrange = JSON.parse(JSON.stringify(self.form.items));
          //  self.newArrange = self.move(toArrange,oldIndex,newIndex);

            const oldIndex = evt.oldIndex;
            const newIndex = evt.newIndex;
            const toArrange = JSON.parse(JSON.stringify(self.form.items));
            const targetRow = toArrange.splice(oldIndex, 1)[0];
            toArrange.splice(newIndex, 0, targetRow);
            self.newArrange = toArrange

          },
          sort : true
        });

        // console.log(self.sortableState)

          //  }


       /*  const d = this.$refs.itemTable;

        console.log(d)
      const tbody = document.querySelector('#itemTable .el-table__body-wrapper table.el-table__body tbody')
        self.sortableState = Sortable.create(tbody,{
          onEnd: function (evt) {
          //   const oldIndex = evt.oldIndex;
          //   const newIndex = evt.newIndex;
          //   const toArrange = JSON.parse(JSON.stringify(self.form.items));
          //  self.newArrange = self.move(toArrange,oldIndex,newIndex);

            const oldIndex = evt.oldIndex;
            const newIndex = evt.newIndex;
            const toArrange = JSON.parse(JSON.stringify(self.form.items));
            const targetRow = toArrange.splice(oldIndex, 1)[0];
            toArrange.splice(newIndex, 0, targetRow);
            self.newArrange = toArrange

            console.log(toArrange)

           alert(1)
          },
          sort : true
        }); */
    },
    disableSortable(){
        const self = this;
        if(Object.keys(self.sortableState).length !== 0){
        const tbody = this.$refs.itemTable.$el.querySelector(
            ".el-table__body-wrapper tbody"
          );

          self.sortableState = Sortable.create(tbody,{
          onEnd: function (evt) {
          //   const oldIndex = evt.oldIndex;
          //   const newIndex = evt.newIndex;
          //   const toArrange = JSON.parse(JSON.stringify(self.form.items));
          //  self.newArrange = self.move(toArrange,oldIndex,newIndex);

            const oldIndex = evt.oldIndex;
            const newIndex = evt.newIndex;
            const toArrange = JSON.parse(JSON.stringify(self.form.items));
            const targetRow = toArrange.splice(oldIndex, 1)[0];
            toArrange.splice(newIndex, 0, targetRow);
            self.form.items = toArrange

          //   console.log(toArrange)

          //  alert(1)
          },
          sort : true
        });
        }


    },
    enableSortable(){
        const self = this;

    /*   const tbody = document.querySelector('#itemTable .el-table__body-wrapper table.el-table__body tbody')
        self.sortableState = Sortable.create(tbody,{
          onEnd: function (evt) {


            const oldIndex = evt.oldIndex;
            const newIndex = evt.newIndex;

            const targetRow = self.form.items.splice(oldIndex, 1)[0];
            self.form.items.splice(newIndex, 0, targetRow);

            const toArrange = JSON.parse(JSON.stringify(self.form.items));
           self.newArrange = self.move(toArrange,oldIndex,newIndex);
          },
          sort : self.sortableStateStatus
        }); */
    },
    customLabel({label , mobile}){
      return `${label} – ${mobile}`
    },
    fnGetContacts(params){
      const self = this;
      const contacts = []
      this.GetContacts(params).then((response) => {
          if(response.length > 0){
            response.forEach((element) => {
              contacts.push({
                opt : element.label + " " + element.mobile,
                label : element.label,
                value : element.value,
                mobile : element.mobile,
                address : element.address,
              })
            })
          }

      })

      self.customer = contacts;
    },
    async setPreparedBy(){
        var self = this;
        const loggedUser = await userData()

        const frm = this.form
        frm.sold_by = loggedUser.user.name
        this.form = frm;
    },


  deleteItem(){

    if(this.selected.length){
        if(this.formStatus === 'update'){
            MessageBox.confirm('This will permanently delete the file. Continue?', 'Warning', {
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancel',
              type: 'warning'
              }).then(() => {
                  this.selected.forEach(element => {
                    var removeIndex = this.form.items.map(function(item) { return item.code; }).indexOf(element.code);
                    this.form.items.splice(removeIndex, 1);
                  });

                  if(this.form.items.length <= 0){

                  const formItemVar = this.formItemVar();
                    this.form.items.push(formItemVar)
                  }
              })
        }else{
          this.selected.forEach(element => {
                    var removeIndex = this.form.items.map(function(item) { return item.code; }).indexOf(element.code);
                    this.form.items.splice(removeIndex, 1);
                  });

                  if(this.form.items.length <= 0){
                    const formItemVar = this.formItemVar();
                    this.form.items.push(formItemVar)
                  }
        }



    }


// remove object


},

handleSelectionChange(v){

    this.selected = v

},
addNewRow(index){
   /*   */

    var dataLength = this.form.items.length - 1;

    if(dataLength === index){
        const item = this.form.items[index];
        if(item.code !== null && item.description !== null){
              const formItemVar = this.formItemVar();
              this.form.items.push(formItemVar)

            }
    }

},

getSelected(v,index){
  const getSelected = this.items.filter(item => {
        return (item.code === v)
    })[0];

    if(getSelected){

      const qty = 1;
      let price = getSelected.price;
      let discount = 0;
      let remarks = null;

/*       if(getSelected.qty <= 0){
          remarks = "To be order";
      } */

      if(getSelected.promotions.length > 0){
        const itemPromo = getSelected.promotions[0];

        const cd = {
          apply: true,
          discount: 0,
          off_price: 0,
          promo: 0,
        }

        discount = this.computeDiscount(qty,price,itemPromo,'promo',cd);
          remarks = this.setRemarks(qty,itemPromo);
           this.$set(this.form.items[index], 'discount_type','promo');
      }

      this.$set(this.form.items[index], 'category', getSelected.category)
      this.$set(this.form.items[index], 'item_id', getSelected.id)
      this.$set(this.form.items[index], 'name', getSelected.label)
      this.$set(this.form.items[index], 'default', getSelected.default)
      this.$set(this.form.items[index], 'qty', qty)
      this.$set(this.form.items[index], 'promotions', getSelected.promotions)
      this.$set(this.form.items[index], 'formatted_price', getSelected.formatted_price)
      this.$set(this.form.items[index], 'price', price)
      this.$set(this.form.items[index], 'amount', this.computeAmount(qty, price))
      this.$set(this.form.items[index], 'discount', discount)
      this.$set(this.form.items[index], 'remarks', remarks)
      this.$set(this.form.items[index], 'total', this.computeTotalAmount(qty, price, discount))
      this.newArrange = this.move(this.form.items,index,index);

      var dataLength = this.form.items.length - 1;
        if(dataLength === index){
            const formItemVar = this.formItemVar();
              this.form.items.push(formItemVar)
        }
    }
},

statusKeyUpFocus(){

  const localItems = this.items;
  const filterOnFocus = [];
  if(localItems.length > 0){
    localItems.forEach(item => {
      if(this.itemSeries.indexOf(item.code) < 0){
        filterOnFocus.push(item)
      }
    });

    this.items = filterOnFocus
  }


},

dispatchFilterItems(params){
  const results = [];
  this.filterItems(params).then((response) =>{
        if(response.length > 0){
          response.forEach(element => {
            results.push({label : element.name, code : element.series,formatted_price : element.formatted_price,price : element.sale_price, id : element.mdbID,promotions : element.promotions,eta : element.order_eta,qty : element.qty,future : element.future_stock, default : element.default,category : element.category, remaining : element.remaining})
          });
        }
    })
  this.items = results

},

statusKeyUp(v){
// this.getPurchaseOrder(v)

const params = {term : v, items : this.itemSeries,transaction_date : this.form.date};
        this.dispatchFilterItems(params)
},
 openDialog(){
        this.$refs.window.openDialog();
      },
      nextCode(){
        var self = this;
      },
/* end */
      closeDialog(){
          this.$refs.window.closeDialog()
      },



      onSubmitForm(){
        var self =this
            this.validated = true
            const isValid = this.$refs.observer.validate();
            this.showError = false
            if (isValid) {
                // this.form.description = this.getText();
                    if(self.formLoading === false){
                      self.formLoading = true
                      if(self.formStatus == 'create'){

                        if(self.newArrange.length > 0){
                          self.form.items = self.newArrange
                        }
                          self.storeRecord(self.form).then((response) => {
                              self.$ThatsNotify.success()
                              self.$emit('success')
                              self.setFormStatusUpdate()
                              self.setFormRecord(response)
                              self.formLoading = false
                              self.SetPage(1)
                              self.newArrange = []
                            }).catch((error) => {
                              self.formLoading = false
                              self.response.error = 1;
                              if (error.response) {
                                  if(error.response.data.hasOwnProperty('errors')){
                                    self.$refs.observer.setErrors(error.response.data.errors);
                                    this.showError = true
                                  }
                                } else if (error.request) {
                                    self.response.message = error.request
                                } else {
                                    self.response.message = error.message
                                }
                                return;
                            })
                      }

                      if(self.formStatus == 'update'){

                        if(self.newArrange.length > 0){
                          self.form.items = self.newArrange
                        }

                        self.modify = false
                          self.updateRecord(self.form).then(() => {
                              self.$ThatsNotify.success({
                                message : "Record was successfully updated"
                              })
                              self.$emit('success')
                              self.setFormRecord(response)
                              self.formLoading = false
                              self.newArrange = []
                              self.selected = []
                              self.returmItem = false
                              self.modify = false

                            }).catch((error) => {
                              self.formLoading = false
                              self.modify = false
                              self.response.error = 1;
                              if (error.response) {
                                  if(error.response.data.hasOwnProperty('errors')){
                                    self.$refs.observer.setErrors(error.response.data.errors);
                                    this.showError = true
                                  }
                                } else if (error.request) {
                                    self.response.message = error.request
                                } else {
                                    self.response.message = error.message
                                }
                                return;
                            })
                      }
                    }

            }
      },

      getText() {
        let text = this.$refs.descriptionEditor.$children;
        text = text.$el.innerHTML;
        return text;
      },
      FormResetter(){
        this.form = this.formVar()
        const formItemVar = this.formItemVar()
        this.form.items.push(formItemVar)
        this.setPreparedBy()
        requestAnimationFrame(() => {
              this.$refs.observer.reset();
            });
        this.validated = false
        this.formLoading = false
        this.sendLoading = false
        this.setFormStatusCreate();
        this.showError = false
        this.currentDateSetter();
        this.tabs = [
                { text: 'Sales Details', slot: 'form-slot' }
              ]
        this.disabled = false
        this.modify = false
        this.returmItem = false
        this.modifyReturmItem = false
        this.newArrange = []

      },

      currentDateSetter(){
        var MyDate = new Date();
        var date =MyDate.getFullYear()  + '-' + ('0' + (MyDate.getMonth()+1)).slice(-2) +'-'+ ('0' + MyDate.getDate()).slice(-2);
        this.form.date = date;
      },
      dialogState(state){
        this.active = 0;
        this.optionsHandler();
        if(!state){
          this.FormResetter();
          // this.disableSortable()
          return
        }

        if(this.formStatus == 'create'){
          this.FormResetter();
          this.initSortable();
            this.nextCode();
            this.tabs = [
                { text: 'Sales Details', slot: 'form-slot' }
              ]

        }

        // alert("dialog State " + this.formStatus)

      },
      emitDelete(){
        this.$emit('delete',this.FormRecord)
      },

      computeDiscount(qty,price,promo,discount_type,custom_discount){

        if(discount_type !== null){
          let discountPrice = 0
          let apply = false;
          let discount = 0;
            if(discount_type === 'promo'){
                apply = promo.apply
                discount = promo.discount
              }else{
                if(custom_discount !== null){
                  if(custom_discount.hasOwnProperty("apply")){
                    apply = custom_discount.apply;
                  }
                  if(custom_discount.hasOwnProperty("discount")){
                    discount = custom_discount.discount;
                  }
                }


            }
           const p = parseFloat(price) * qty;

                  if(apply === true){
                    discountPrice = parseFloat(p) * (discount / 100);
                  }else{
                    discountPrice = parseFloat(discount) * qty;
                  }
          return discountPrice;
        }
        return 0;
      },


      setRemarks(qty,promo){
          if(promo.apply === true){
              if(promo.discount > 0){
                return `${promo.discount}% Discount`;
              }else{
                return "";
              }
          }else{
            if(promo.discount > 0){
                return `${this.formatNumber(((promo.discount) * qty))} QAR Off`;
              }else{
                return "";
              }
          }
      },
      computeAmount(qty,price){
          return this.formatNumber((qty * parseFloat(price)));
      },
      computeTotalAmountNumber(qty,price,discount){
        const d = parseFloat(discount);
        const amount = qty * parseFloat(price);
        const totalAmount = amount - d;
          return ((d > 0) ? totalAmount : amount);
      },
      computeTotalAmount(qty,price,discount){
        const d = unformat(discount);
        const amount = qty * unformat(price);
        const totalAmount = amount - d;
          return this.formatNumber(((d > 0) ? totalAmount : amount));
      },

      calculate(index){
        const self = this;
        // console.log(event);
          if(typeof self.form.items[index] !== 'undefined') {
              const item = self.form.items[index];

              let discount = 0;
              let remarks = null;

              if(item.promotions.length > 0){
                  const itemPromo = item.promotions[0];
                  discount = this.computeDiscount(item.qty,item.price,itemPromo,item.discount_type,item.custom_discount);
                  remarks = this.setRemarks(item.qty,itemPromo)
                }

                if(item.discount_type === 'discount'){
                  const itemPromo = item.promotions[0];
                  discount = this.computeDiscount(item.qty,item.price,itemPromo,item.discount_type,item.custom_discount);
                  remarks = this.setRemarks(item.qty,item.custom_discount);
                  // frm.total = this.computeTotalAmount(qty, price, frm.discount)
                }


              if(item.code !== null && item.name !== null){
                 const amount = this.computeAmount(item.qty,item.price);
                 const totalAmount = this.computeTotalAmount(item.qty,item.price,discount);
                 this.$set(self.form.items[index], 'remarks',remarks)
                 this.$set(self.form.items[index], 'discount', this.formatNumber(discount))
                 this.$set(self.form.items[index], 'amount', amount)
                 this.$set(self.form.items[index], 'total', totalAmount)

              }
          }
      },

      formatNumber(n) {
        return parseFloat(n).toFixed(2).replace(/./g, function(c, i, a) {
          return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
        });
      },
      fnPrint(url){

        var strWindowFeatures = "location=yes,height=600,width=900,scrollbars=yes,status=yes";
        const win = window.open(url, "_blank", strWindowFeatures);
        win.document.title = 'Print';
        win.print()

      },


      toggleCheck(){
        const self = this;
        if(this.form.transaction.items.length > 0){
          const getCode = this.form.items.map(i => i.code);

          if(getCode.length > 0){
              self.$nextTick(() => {
                self.form.transaction.items.forEach((item,index) => {
                    if(getCode.includes(item.code)){
                      self.$refs.itemsTable.toggleRowSelection(item,true);
                      // alert(index)
                    }
                })

              })



              }else{
                self.$refs.itemsTable.clearSelection();
              }

        }
      },

      getRowKey(row){
        return row.code
      },
      fuseSearch(options, search) {
      const fuse = new Fuse(options, {
        keys: ["mobile", "label"],
        shouldSort: true
      });
      return search.length
        ? fuse.search(search).map(({ item }) => item)
        : fuse.list;
    },

    searchCustomer(v){
        const self = this;
        if(v !== ""){
            this.fnGetContacts({term : v})
        }
    },
      getCustomerSelected(v){
        const selectedCustomer = this.customer.filter(c => {
            return c.value === v;
        })[0];

        if(selectedCustomer !== null){
            this.form.attr.name = selectedCustomer.label
            this.form.attr.mobile = selectedCustomer.mobile
            this.form.attr.address = selectedCustomer.address
        }

      },

      openCustomer(){
        this.$refs.contactForm.openDialog();
      },
      contactSuccess(v){
        const contact = { label: v.name, value: v.mdbID, mobile: v.mobile, address : v.address }
        this.customer.unshift(contact);
        this.form.customer_id = v.mdbID
        this.form.mobile = v.mobile
        this.form.attr.name = v.name;
        this.form.attr.mobile = v.mobile;
        this.form.attr.address = v.address;

        // alert(v.name)
      },

      openPayment(paymentRow){
        this.paymentFormStatus = 'update'
        this.paymentForm = paymentRow
        this.paymentForm.invoice_series = this.form.series
        this.paymentForm.customer = this.form.attr.name + " "+ this.form.attr.mobile
        this.$refs.updatePaymentForm.openDialog();
      },
      openUpdatePaymentWindow(){
        this.paymentFormStatus = 'create'
        const pForm = {...this.paymentForm,invoice_series : this.form.seires, customer : this.form.attr.name + " "+ this.form.attr.mobile}
        // this.paymentForm.invoice_series = this.form.series
        this.paymentForm = pForm
        this.$refs.updatePaymentForm.openDialog();
      },
      addMoreDiscount(){

      },
      sendRequest(){
        if (this.request) this.cancelRequest();
          this.makeRequest()
      },
      cancelRequest(){
        this.request.cancel();
      this.clearOldRequest("Cancelled");
      },

      makeRequest(){
const axiosSource = axios.CancelToken.source();
          this.request = { cancel: axiosSource.cancel, msg: "Loading..." };
          axios
            .get("/api/user/filter", { cancelToken: axiosSource.token })
            .then(() => {
              this.clearOldRequest("Success");
            })
            .catch(this.logResponseErrors);
      },
      logResponseErrors(err) {
      if (axios.isCancel(err)) {
        // console.log("Request cancelled");
      }
    },
      clearOldRequest(msg) {
        this.request.msg = msg;
        this.requests.push(this.request);
        this.request = null;
      },

      enableModify(){
        this.modify = true
        this.disabled = false
        this.returmItem = false
        if(this.form.items.length === 0){
          const formItemVar = this.formItemVar();
            this.form.items.push(formItemVar)
        }
        this.initSortable();
      },
      enableModifyCreditNote(){
        this.modifyReturmItem = true
        this.modify = false
        this.disabled = false
        this.returmItem = false
      },

       openLink(target) {
        // console.log(target);
      },
      copyLink(target) {
        console.log(target);
      },

      rowContectMenu(row,col,e){
        const self = this
        // console.log(col)
        // console.log(row)
        // console.log(e)
        if((row.code !== null && this.formStatus === 'create') || (this.formStatus === 'update' && row.code !== null && (this.modify === true || this.form.invoice.series === null))){
            this.context = row
            this.viewMenu = true;
              this.$nextTick(function() {
                self.$refs.right.focus();
                self.setMenu(e.y, e.x)
              }.bind(this));
              e.preventDefault();
        }
      },

      setMenu: function(top, left) {

        const largestHeight = window.innerHeight - this.$refs.right.offsetHeight - 75;
            const largestWidth = window.innerWidth - this.$refs.right.offsetWidth - 75;

            if (top > largestHeight) top = largestHeight;

            if (left > largestWidth) left = largestWidth;

            this.top = top + 'px';
            this.left = left + 'px';
        },

        closeMenu: function() {
            this.viewMenu = false;
            this.context = null
        },

        deleteRow(){
          const self = this
            if(this.context != null){

              if(self.context.hasOwnProperty('id')){
                   const matchItem = this.form.items.filter((i) => {
                    return i.id != self.context.id;
                  })
                  self.form.items = matchItem
              }
              if(self.context.hasOwnProperty('item_id')){
                   const matchItem = this.form.items.filter((i) => {
                    return i.item_id != self.context.item_id;
                  })
                  self.form.items = matchItem
              }
              /* const matchItem = this.form.items.filter((i) => {
                return i.code != self.context.code;
              }) */


/*               console.log(this.context)
              console.log(self.form.items) */
              this.closeMenu()
            }

        },
        moveUpRow(){
           const self = this
            if(this.context != null){
              const index = this.form.items.findIndex(e => e.code == self.context.code);

              if (index > 0) {
                const el = this.form.items[index];
                this.$set(this.form.items, index, this.form.items[index - 1]);

                this.$set(this.form.items, index - 1, el);
                this.closeMenu()
              }
            }
        },
        moveDownRow(){
           const self = this
            if(this.context != null){
              const index = this.form.items.findIndex(e => e.code == self.context.code);

                  if (index !== -1 && index < self.form.items.length - 2) {
                    const el = self.form.items[index];
                    this.$set(self.form.items, index, self.form.items[index + 1]);
                    this.$set(self.form.items, index + 1, el);
                    this.closeMenu()
                  }

            }
        },

        cancelModification(){

          const self = this;
            self.modifyReturmItem = false
            self.returmItem = false
            self.modify = false
            self.disabled = true
            self.selected = []
          // self.getRecord({token_id : self.form.token_id})

            const frmOriginal = JSON.parse(JSON.stringify(this.formOriginal));

            self.setFormRecord(frmOriginal)

        },

        insertRow(){
            const self = this
            if(this.context != null){
              if(self.context.hasOwnProperty('id')){
                const index = this.form.items.findIndex(e => e.id == self.context.id);
                const formItemVar = this.formItemVar();
                this.form.items.splice((index + 1), 0, formItemVar);
              }
              if(self.context.hasOwnProperty('item_id')){
                const index = this.form.items.findIndex(e => e.item_id == self.context.item_id);
                const formItemVar = this.formItemVar();
                this.form.items.splice((index + 1), 0, formItemVar);
              }
              this.closeMenu()
            }


        },

        returnItems(){
          this.returmItem = true;
        },
        cancelReturnItems(){
          this.returmItem = false;
          this.selected = [];
        },
        requestCreditNote(){
          const self = this;
          const params = {
            transaction_id : this.form.mdbID,
            items : this.selected,
          }

          self.formLoading = true
          this.storeCreditNote(params).then((response) => {

              self.$ThatsNotify.success({
                                message : response.message
                              })
              self.$emit('success')
              self.setFormRecord(response.data)
              self.formLoading = false
              self.newArrange = []
              self.selected = []
              self.returmItem = false
              self.modify = false
          })
        },
        canSelectRow(row, index){

          if(this.formStatus === 'update' && (this.form.invoice !== null && this.form.invoice.series !== null) && this.modify === false && this.returmItem === true){
              const creditNotes = this.form.credit_note_items.map(i => i.code);
              if(creditNotes.includes(row.code)){
                return false
              }else{
                return true
              }
          }else{
            return true
          }
        },
        enableRow(row){

          if(this.formStatus === 'update' && (this.form.invoice !== null && this.form.invoice.series !== null) && this.modify === false && this.returmItem === true){
              const creditNotes = this.form.credit_note_items.map(i => i.code);
              if(creditNotes.includes(row.code)){
                return false
              }else{
                return true
              }
          }else{
            return true
          }
        },

        enableModifyAndCreditNote(row){
          if(this.disabled === false ||
            ((this.invoice.series !== null && ((this.form.status === 'delivered' || this.form.status === 'collected') && this.form.attr.payment_status === 'full-payment')) &&
            (this.checkSystemSupport || this.checkShowroomManager) &&
            (this.returmItem === true || this.modify === true))){
              // return false

              if(this.formStatus === 'update' && (this.form.invoice !== null && this.form.invoice.series !== null) && this.modify === false && this.returmItem === true){
                  const creditNotes = this.form.credit_note_items.map(i => i.code);
                  if(creditNotes.includes(row.code)){
                    return true
                  }else{
                    return false
                  }
              }else{
                return false
              }

          }
          return true
      },

      handleCheckAllChange(val) {
        var self = this;
          this.isIndeterminate = false;
          this.form.items.forEach((row,index) => {
            self.$set(self.form.items,index, {...row,tbo : val});
          })


      },
      handleCheckedTboChange(value) {
        const self = this;
        const checked = this.form.items.filter(row => {
          return row.tbo === true
        }).map(e => e.tbo).length;

        const isIndeterminate = checked > 0 && checked < this.form.items.length;

        const checkAllTbo = checked === this.form.items.length

        this.$nextTick(() => {
            self.isIndeterminate = isIndeterminate
            self.checkAllTbo = checkAllTbo
        });

        /* this.sele
        console.log((checked > 0 && checked < this.form.items.length)) */
      },

      renderHeader(h,{column}){
      return h(
        'div',
        [
          h('span', column.label),
          h('el-checkbox',{
            style:'display:inline-flex;margin-left:5px;',
            on:{
              Change: ($event, column) => this.select($event, column), // check the event $event, column, where $event=true, column is the input dom when printing in select
            }
          }),
        ],
      )
    },

    select(obj, $event = this.targetEv){
      console.log(obj)
      console.log($event)
    },

    enablePrice(row){
      // console.log("enable price")
      // console.log(row.category)
    const cat = [137, 136, 126, 83, 127, 129, 132, 130, 135, 128 ];
    /* 137, 136, 126, 83, 127, 129, 132, 130, 135 */
      // console.log(cat.includes(row.category))
      if((this.$helpers.isSalesExecutive() || this.$helpers.isSystemAdministrator()) && row.category !== null && cat.includes(row.category)){
        return true;
      }
      return false
    },

    calculatePrice(index){
      const self = this
      const item = self.form.items[index];

       this.$set(self.form.items[index], 'price',unformat(item.formatted_price))

       if(typeof self.form.items[index] !== 'undefined') {
              const item = self.form.items[index];

              let discount = 0;
              let remarks = null;

              if(item.promotions.length > 0){
                  const itemPromo = item.promotions[0];
                  discount = this.computeDiscount(item.qty,item.price,itemPromo,item.discount_type,item.custom_discount);
                  remarks = this.setRemarks(item.qty,itemPromo)
                }

                if(item.discount_type === 'discount'){
                  const itemPromo = item.promotions[0];
                  discount = this.computeDiscount(item.qty,item.price,itemPromo,item.discount_type,item.custom_discount);
                  remarks = this.setRemarks(item.qty,item.custom_discount);
                }


              if(item.code !== null && item.name !== null){
                 const amount = this.computeAmount(item.qty,item.price);
                 const totalAmount = this.computeTotalAmount(item.qty,item.price,discount);
                 this.$set(self.form.items[index], 'remarks',remarks)
                 this.$set(self.form.items[index], 'discount', this.formatNumber(discount))
                 this.$set(self.form.items[index], 'amount', amount)
                 this.$set(self.form.items[index], 'total', totalAmount)

              }
          }


    },

    removeFormat(index){
      // console.log(row)
      const self = this;
       const item = self.form.items[index];
//  console.log("focus")
//        console.log(item)
      let amount = 0
      if (item.price !== 0) {
        amount = formatMoney(item.price, {
          symbol: '',
          format: '%v',
          thousand: '',
          decimal: '.',
          precision: 2
        })
      }

      this.$set(self.form.items[index], 'formatted_price',amount)
    },
    formatOnBlur(index){
      // console.log(row)
      const self = this;
       const item = self.form.items[index];

       console.log("blur")
       console.log(item)

      let amount = 0
      if (item.formatted_price !== 0) {
        amount = formatMoney(item.formatted_price, {
          symbol: '',
          format: '%v',
          thousand: ',',
          decimal: '.',
          precision: 2
        })
      }

      this.$set(self.form.items[index], 'formatted_price',amount)
      this.$set(self.form.items[index], 'price',unformat(amount))

    },

    quantityChange(v){
        // console.log(v)
        const code = v.code;
        const qty = parseInt(v.qty);
          if(qty > v.max){
              v.qty = v.max;
          }
          if(qty < 1){
            v.qty = 1;
          }
      },




    },

    computed: {

      ...mapGetters('TransactionModule',
      [
        'formStatus',
        'formRecord',
        'viewLoading',
        'tblKey',
      ]),

...mapGetters('AuthModule',[ 'user', ]),

      itemSeries : function(){
          var self = this;
          const filteredSeries = self.form.items.filter((item) => {
              return (item.code !== "" && item.code !== null)
          }).map(function(key){
                return key.code
          })


          return filteredSeries;
      },

      noInvoiceDisabled : function(){
          if(this.formStatus === 'create' || this.form.invoice === null || (this.form.invoice !== null && this.form.invoice.series === null)){
            return true;
          }
          return false
      },


      invoice : function(){
          let inv = {
          series : null,
          date : "",
          balance : 0,
          paid : 0,
          attachment : [],
          payments : [],
        }

        if(this.formStatus == 'update'){
            if(this.formRecord != null && this.formRecord.invoice !== null){
              inv = this.formRecord.invoice
            }

        }

        inv.balance = unformat(inv.balance)
        return inv
      },

      checkSystemSupport : function(){
          return this.$helpers.isSystemAdministrator();
      },
      checkShowroomManager : function(){
          return this.$helpers.isShowroomManager();
      },
      showCheckBox : function(){
        if(this.formStatus == 'create' || (this.formStatus == 'update' && this.returmItem === true)){
            return true;
        }

        return false;
      },
      showCheckBoxCreditNote : function(){
        if(this.formStatus == 'update' && this.modifyReturmItem === true){
            return true;
        }

        return false;
      },
      compareValues(key, order = 'asc') {
        return function innerSort(a, b) {
          if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
            // property doesn't exist on either object
            return 0;
          }

          const varA = (typeof a[key] === 'string')
            ? a[key].toUpperCase() : a[key];
          const varB = (typeof b[key] === 'string')
            ? b[key].toUpperCase() : b[key];

          let comparison = 0;
          if (varA > varB) {
            comparison = 1;
          } else if (varA < varB) {
            comparison = -1;
          }
          return (
            (order === 'desc') ? (comparison * -1) : comparison
          );
        };
      },

      hasSelected(){
        if(this.selected.length > 0){
          return false;
        };
        return true
      },



      hasInvoice(){
        if(this.form.invoice !== null && this.form.invoice.series !== null){
          return true;
        }
        return false;
      },

      toBeOrder(){
        return this.form.items.map(i => i.tbo).lenth;
      }


    },

    watch: {
      tblKey : function(){
          this.initSortable();
      },

      // viewLoading : function(v){
      //     if(v === false && this.formStatus === 'update'){
      //          if(this.form.invoice !== null  && (v.invoice.hasOwnProperty('series') && v.invoice.series !== null)){
      //            alert("watch viewloading invoiced")

      //          }else{
      //            alert("watch viewloading update quotation")
      //          }
      //     }
      // },
      formRecord : function(v){
        const self = this;
        this.active = 0;
          this.disabled = false
        // alert(this.formStatus);

        if(this.formStatus == 'update'){
          // alert("update")
            // if(!this.viewLoading){
              if(v.invoice !== null && (v.invoice.hasOwnProperty('series') && v.invoice.series !== null)){
                // alert()
                  if(this.modify === false){
                    this.disableSortable();
                  }
                  this.disabled = true
                      this.tabs = [
                        { text: 'Sales Details', slot: 'form-slot' },
                        { text: 'Sales Invoice', slot: 'invoice-slot' },
                        { text: 'Attachments', slot: 'form-attachment' }
                      ]

                      // alert("invoiced")
                  }else{
                    this.form.invoice = {
                        series : null,
                        date : "",
                        balance : 0,
                        paid : 0,
                        attachment : [],
                        payments : [],
                    }
//  alert("quotation")
                    // this.initSortable();

              }
            // }


                const jsonParse = JSON.parse(JSON.stringify(this.formRecord));

                if(jsonParse.hasOwnProperty('attr')){
                  jsonParse.attr = {...this.form.attr,...jsonParse.attr}
                }
                jsonParse.more_discount = {...this.form.more_discount,...jsonParse.more_discount}


                // const sortItems =

                // jsonParse.items = jsonParse.items.sort((a, b) => a.sort > b.sort);
                jsonParse.items = jsonParse.items.sort((a, b) => (a.sort > b.sort ? 1 : -1));
                // jsonParse.items = jsonParse.items.sort(self.compareValues('sort','asc'));


                this.form = jsonParse;
                this.formOriginal = JSON.parse(JSON.stringify(jsonParse));

                // this.newArrange = jsonParse.items;

                if(this.form.hasOwnProperty('credit_note_items') && this.form.credit_note_items.length > 0){
                  this.tabs = [...this.tabs,{ text: 'Credit Notes', slot: 'credit-notes' }];
                }
                if(this.form.hasOwnProperty('delivery_notes') && this.form.delivery_notes.length > 0){
                  this.tabs = [...this.tabs,{ text: 'Delivery Notes', slot: 'delivery-notes' }];
                }


                if(!this.disabled){
                  const formItemVar = this.formItemVar();
                  this.form.items.push(formItemVar)
                }


          if(Object.keys(v).length !== 0 && v.constructor === Object){
            this.customer = [{
                opt : this.form.attr.name + " "+ this.form.attr.mobile,
                label :this.form.attr.name,
                value : this.form.customer_id,
                mobile : this.form.attr.mobile,
                address : this.form.attr.address,
            }];
          }


        }

        if(this.formStatus == 'create'){
          this.FormResetter();
          // this.initSortable();
          // alert("watch create")
        }
      },

      'form.items' : {
          handler: function(v) {
            if(v.length > 0){
              const total = v.map((i) => {
                return unformat(i.total);
              }).reduce((a,b) => {
                return a + b;
              })
              const formTotal = formatMoney(total, { symbol: "", precision: 2, thousand: ",", decimal: "." });
              if(this.form.more_discount.enable){
                    const unformatedFormTotal = unformat(formTotal);
                    const discount = this.form.more_discount.discount;
                    this.form.total = formatMoney((unformatedFormTotal - discount), { symbol: "", precision: 2, thousand: ",", decimal: "." });
                }else{
                  this.form.total = formTotal
                }
                this.total = formTotal;

              /*   this.selectedTbo = v.filter((e) => {
                      return e.tbo === true
                }) */


            }

          },
          deep: true
      },
      "form.more_discount.discount" : function(v){
          const discount = unformat(v);
          const total = unformat(this.total);
            this.form.total = formatMoney((total - discount), { symbol: "", precision: 2, thousand: ",", decimal: "." });

          if(this.form.more_discount.enable === false){
            this.form.total = formatMoney(total, { symbol: "", precision: 2, thousand: ",", decimal: "." });
          }


/*
          if(this.form.more_discount.enable){
                    const unformatedFormTotal = unformat(this.form.total);
                    this.form.total = formatMoney((unformatedFormTotal - discount), { symbol: "", precision: 2, thousand: ",", decimal: "." });
          }else{
            this.form.total = formatMoney(total, { symbol: "", precision: 2, thousand: ",", decimal: "." });
          } */
      },
      "form.more_discount.enable" : function(v){
        const discount = unformat(this.form.more_discount.discount);
          const total = unformat(this.total);
          this.form.total = formatMoney((total - discount), { symbol: "", precision: 2, thousand: ",", decimal: "." });
            // alert(typeof v + " ==== " + total + "-" + discount)
          if(v === false){
                this.form.total = formatMoney(total, { symbol: "", precision: 2, thousand: ",", decimal: "." });
          }


            // this.form.more_discount = false;
          //   alert(1)
          //   this.form.total = formatMoney(total, { symbol: "", precision: 2, thousand: ",", decimal: "." });
          // }
          // if(this.form.more_discount === false){
          //   alert(false)
          //   this.form.total = formatMoney(total, { symbol: "", precision: 2, thousand: ",", decimal: "." });
          // }
      }

    },




}
</script>

<style scoped>
.click-to-add-logo{
  font-size: 14px;cursor: pointer;
}



.custom-control {
    position: absolute!important;
    margin: 10px!important;
}

.custom-control.image-delete{
  right: 0;cursor: pointer;
}

.custom-checkbox .custom-control-label::before {
    border-radius: .50rem!important;cursor: pointer;
}

.no-image-gallery{
  padding: 65px;
  text-align: center;
}

.no-image-gallery i.far {
  font-size: 42px;
  color: #959595;
}
a.discount-a{
  margin : 5px;
}

.tab-content{
  height: auto!important;
}


</style>
